import { CheckoutSession, postCreateCheckoutSession } from '@nemuru-eng/js-api-client';

export const BillingAndShippingMap = {
  billingToRequestDto: (
    data: CheckoutSession['billing'],
  ): Parameters<typeof postCreateCheckoutSession>[0]['billing'] => {
    if (!data) {
      return;
    }

    return {
      firstName: data.customer.name.first,
      lastName: data.customer.name.last,
      company: data.businessName ?? undefined,
      corporateIdNumber: data.corporateIdNumber ?? undefined,
      email: data.customer.email ?? undefined,
      phoneNumber: data.customer.phone ?? undefined,
      address: data.address,
    };
  },

  shippingToRequestDto: (
    data: CheckoutSession['shipping'],
  ): Parameters<typeof postCreateCheckoutSession>[0]['shipping'] => {
    if (!data) {
      return;
    }

    return {
      name: data.name,
      method: data.method ?? undefined,
      firstName: data.customer.name.first,
      lastName: data.customer.name.last,
      company: data.businessName ?? undefined,
      email: data.customer.email ?? undefined,
      phoneNumber: data.customer.phone ?? undefined,
      address: data.address,
    };
  },
};
